import { combineReducers } from 'redux'
import {
  createReducer,
  createRequestReducer
} from 'pobble-components/dist/redux-helpers'
import { schema, normalize } from 'normalizr'

const normalizeOrganisationFiles = data => {
  const organisationFile = new schema.Entity('organisationFiles')
  return normalize(data, [organisationFile])
}

const OrganisationFilesReducer = combineReducers({
  fetchOrganisationFilesRequest: createRequestReducer(
    'ORGANISATION_FILES:FETCH'
  ),
  filters: createReducer(
    { benchmarked: false },
    {
      'ORGANISATION_FILES:FILTER_BENCHMARK': state => ({
        ...state,
        benchmarked: true
      }),
      'ORGANISATION_FILES:FILTER_ALL': state => ({
        ...state,
        benchmarked: false
      })
    }
  ),
  organisationFiles: createReducer(null, {
    'ORGANISATION_FILES:FETCH_REQUEST_SUCCESS': (state, { response }) => {
      return normalizeOrganisationFiles(response.data.assessment_files)
    }
  })
})

export default OrganisationFilesReducer
